import { ModuleFE_LogTemplate } from './ModuleFE_LogTemplate.js';
export const ModulePackFE_LogTemplateDB = [ModuleFE_LogTemplate];
//# sourceMappingURL=module-pack.js.map